module.exports = __webpack_public_path__ + "img/ah.28e40ec2.png";